import React from 'react';
import styles from './Loading.module.scss';
import PropTypes from 'prop-types';

const Loading = ({ children }) => {
  return (
    <section className={styles.loading}>
      {children ? children : 'Loading...'}
    </section>
  );
};

Loading.propTypes = {
  children: PropTypes.node,
};

Loading.defaultProps = {
  children: null,
};

export default Loading;
